import { render, staticRenderFns } from "./Anzahl.vue?vue&type=template&id=4b61f162&scoped=true"
import script from "./Anzahl.vue?vue&type=script&lang=js"
export * from "./Anzahl.vue?vue&type=script&lang=js"
import style0 from "./Anzahl.vue?vue&type=style&index=0&id=4b61f162&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61f162",
  null
  
)

export default component.exports